import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      flexGrow: 0,
    },
    spinner: {
      marginLeft: 0,
    },
    todaysAbsenceContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    todaysAbsenceLabel: {
      overflow: 'hidden',
    },
    todaysAbsenceStatus: {
      textTransform: 'uppercase',
      fontSize: '0.625rem',
      fontWeight: 500,
      borderRadius: 16,
      padding: theme.spacing(0, 1),
      marginLeft: theme.spacing(),
      '&.approved': {
        backgroundColor: '#43A047',
        color: theme.palette.common.white,
      },
      '&.proposed': {
        backgroundColor: '#FDD835',
        color: theme.palette.common.black,
      },
    },
    buttonContainer: {
      display: 'flex',
    },
    tooltipContainer: {
      display: 'inline-flex',
      overflow: 'hidden',
      width: '100%',
    },
    addSickLeaveButton: {
      fontSize: '0.675rem',
      lineHeight: 1.5,
    },
    secondButton: {
      marginLeft: theme.spacing(1),
    },
    otherAbsencesButton: {
      marginTop: theme.spacing(1),
    },
    myVacationBalance: {
      display: 'flex',
      justifyContent: 'space-between',
      fontWeight: theme.typography.fontWeightBold,
      marginTop: theme.spacing(),
    },
    myVacationBalanceTitle: {
      overflow: 'hidden',
      marginRight: theme.spacing(),
    },
  };
};
